module.exports = __webpack_public_path__ + "media/images/plans/ceremony/about-446c8361860edda95e3ef266f952a345.jpg";